module.exports = __webpack_public_path__ + "img/2_1-industriale-fabbrica_b-0.3557764c.png";